import DataGrid, { Column, Format } from 'devextreme-react/data-grid';
import { formatNumber } from 'devextreme/localization';
import { useContext } from 'react';
import { MaterialOrderContext } from '../context/MaterialOrderContext';
import { MOProduct } from '../types/MaterialOrderDetails';

export default function MaterialOrderProducts() {

    const { order } = useContext(MaterialOrderContext);

    return (
        <>
            <div className='dx-card wide-card'>
                <div className='grid-header'>Material Order Details</div>
                <DataGrid
                    dataSource={order.details.products}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    showBorders={true}
                    showColumnLines={true}
                    columnAutoWidth={true}
                    wordWrapEnabled={true}
                    keyExpr={'moProductID'}
                    className="grid-with-header"
                >
                    <Column
                        dataField={'productLine'}
                        caption={'Product Line'}
                        dataType="string"
                    />
                    <Column
                        dataField={'subProductLine'}
                        caption={'Sub Product Line'}
                        dataType="string"
                    />
                    <Column
                        dataField={'productType'}
                        caption={'Product Type'}
                        dataType="string"
                    />
                    <Column
                        dataField={'sku'}
                        caption={'House PO SKU'}
                        dataType="string"
                        width={100}
                    />
                    <Column
                        dataField={'mfrSku'}
                        caption={'MFR SKU'}
                        dataType="string"
                        width={100}
                    />
                    <Column
                        dataField={'mfrDescription'}
                        caption={'MFR Description'}
                        dataType="string"
                        allowEditing={false}
                        width={200}
                    />
                    <Column
                        dataField={'description'}
                        caption={'Description'}
                        dataType="string"
                        width={200}
                        encodeHtml={false}
                        calculateDisplayValue={(rowData: MOProduct) =>
                            rowData.description.replace(new RegExp('\r\n', 'g'), '<br/>')
                        }
                    />
                    <Column
                        dataField={'thickness'}
                        caption={'Thickness'}
                        dataType="string"
                    />
                    <Column
                        dataField={'dimensions'}
                        caption={'Dimensions'}
                        dataType="string"
                    />
                    <Column
                        dataField={'squareFootage'}
                        caption={'Square Footage'}
                        dataType="string"
                    />
                    <Column
                        dataField={'distributorName'}
                        caption={'Distributor'}
                        dataType="string"
                    />
                    <Column
                        dataField={'uom'}
                        caption={'UOM'}
                        dataType="string"
                    />
                    <Column
                        dataField={'quantity'}
                        caption={'Qty'}
                        dataType="number"
                    />
                    <Column
                        dataField={'pullFromStock'}
                        caption={'Stock'}
                        dataType="boolean"
                    />
                    <Column
                        dataField={'backOrdered'}
                        caption={'Back Ordered'}
                        dataType="boolean"
                    />
                    <Column
                        dataField={'unitCost'}
                        caption={'Unit Cost'}
                        dataType="number"
                    >
                        <Format type="currency" precision={2} ></Format>
                    </Column>
                    <Column
                        dataField={'totalCost'}
                        caption={'Total Cost'}
                        dataType="number"
                    >
                        <Format type="currency" precision={2} ></Format>
                    </Column>
                    <Column
                        dataField={'carrier'}
                        caption={'Carrier'}
                        dataType="string"
                    />
                    <Column
                        dataField={'trackingNbr'}
                        caption={'Tracking Nbr'}
                        dataType="string"
                    />
                    <Column
                        dataField={'productRequestedDeliveryDate'}
                        caption={'Requested Delivery Date'}
                        dataType="date"
                    />
                    <Column
                        dataField={'shippedDate'}
                        caption={'Actual Ship Date'}
                        dataType="date"
                    />
                    <Column
                        dataField={'expectedShipDate'}
                        caption={'Estimated Delivery Date'}
                        dataType="date"
                    />
                </DataGrid>
                <div className='dx-clearfix'>
                    <table className='summary-table'>
                        <tbody>
                            <tr>
                                <td>Subtotal:</td>
                                <td>{formatNumber(order.details.subTotal, { type: 'currency', precision: 2 })}</td>
                            </tr>
                            <tr>
                                <td>Cut Charge:</td>
                                <td>{formatNumber(order.details.cutCharges, { type: 'currency', precision: 2 })}</td>
                            </tr>
                            <tr>
                                <td>Freight:</td>
                                <td>{formatNumber(order.details.freightCharges, { type: 'currency', precision: 2 })}</td>
                            </tr>
                            <tr>
                                <td>Tax Rate:</td>
                                <td>{formatNumber(order.details.taxRate ?? 0, { type: 'percent', precision: 2 })}</td>
                            </tr>
                            <tr>
                                <td>Tax Amount:</td>
                                <td>{formatNumber(order.details.salesTax ?? 0, { type: 'currency', precision: 2 })}</td>
                            </tr>
                            <tr className='total'>
                                <td>Total:</td>
                                <td>{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
